import request from "@/utils/request";
// 获取游戏列表
const getGameList = (params) =>
  request.post("/laiHi/app/webGame/pageWebGame", params);
// 获取游戏信息
const getGameDetails = (params) =>
  request.post("/laiHi/app/webGame/getCoordinate", params);
export { getGameList, getGameDetails };
